import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserService } from '../../services/user';

@Component({
  selector: 'app-recording-preference',
  imports: [ButtonModule],
  templateUrl: './recording-preference.html',
  styleUrl: './recording-preference.css',
  standalone: true,
})
export class RecordingPreferenceDialog {
  private dialogRef = inject(DynamicDialogRef);
  private userService = inject(UserService);

  selectPushToTalk() {
    this.userService.updateRecordingMode('push_to_talk');
    this.dialogRef.close('push_to_talk');
  }

  selectClickToRecord() {
    this.userService.updateRecordingMode('click_to_record');
    this.dialogRef.close('click_to_record');
  }
}
